export default __webpack_public_path__ + "static/media/nftope.8a5c2533.gif";